<template>
  <div class="box">
    <div>
      <div
        class="form-group mt-5 flatpicker-group"
        :class="{ hasValue: showInputStart }"
      >
        <flat-pickr
          ref="datePickerStart"
          @on-change="onStartChange"
          :config="dateConfigStart"
          @input="update()"
          class="form-control"
          :value="value[0]"
        ></flat-pickr>
        <label class="form-control-placeholder">
          {{ config.PlaceholderFrom }}
          <small v-if="!config.Validation.required">Valgfri</small>
        </label>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 2V.852c0-.47.448-.852 1-.852s1 .382 1 .852V2h4v18H0V2h4V.852C4 .382 4.448 0 5 0s1 .382 1 .852V2h8zm-3 13h4v-4h-4v4zm-9 3h16V6H2v12z"
            fill-rule="nonzero"
          />
        </svg>
      </div>
    </div>
    <div>
      <div
        class="form-group mt-5 flatpicker-group"
        :class="{ hasValue: showInputEnd }"
      >
        <flat-pickr
          ref="datePickerEnd"
          @on-change="onEndChange"
          :config="dateConfigEnd"
          @input="update()"
          class="form-control"
          :value="value[1]"
        ></flat-pickr>
        <label class="form-control-placeholder">{{
          config.PlaceholderTo
        }}</label>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 2V.852c0-.47.448-.852 1-.852s1 .382 1 .852V2h4v18H0V2h4V.852C4 .382 4.448 0 5 0s1 .382 1 .852V2h8zm-3 13h4v-4h-4v4zm-9 3h16V6H2v12z"
            fill-rule="nonzero"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
  // https://flatpickr.js.org/examples/
  import flatPickr from 'vue-flatpickr-component';
  import { Danish } from 'flatpickr/dist/l10n/da.js';
  export default {
    props: ['value', 'id', 'config'],
    data() {
      return {
        // Initial value
        showInputStart: '',
        showInputEnd: '',
        tempStart: '',
        tempEnd: '',
        dateConfigGlobal: {
          altFormat: 'j. M Y',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Danish, // locale for this instance only
        },
      };
    },
    computed: {
      dateConfigStart() {
        return { ...this.dateConfigGlobal, ...this.config.dateStart };
      },
      dateConfigEnd() {
        return { ...this.dateConfigGlobal, ...this.config.dateEnd };
      },
    },
    components: {
      flatPickr,
    },
    methods: {
      update() {
        // check if valid
        if (this.tempStart) {
          this.showInputStart = true;
        }
        if (this.tempEnd) {
          this.showInputEnd = true;
        }
        if (this.tempStart && this.tempEnd) {
          this.$emit('input', [this.tempStart, this.tempEnd]);
        }
      },
      onStartChange(selectedDates, dateStr) {
        this.tempStart = dateStr;
        this.$refs.datePickerEnd.fp.set('minDate', dateStr);
        this.$refs.datePickerEnd.fp.redraw();
        this.update();
      },
      onEndChange(selectedDates, dateStr) {
        this.tempEnd = dateStr;
        this.$refs.datePickerStart.fp.set('maxDate', dateStr);
        this.$refs.datePickerStart.fp.redraw();
        this.update();
      },
    },
    mounted() {
      if (this.value[0]) {
        this.showInputStart = true;
      }
      if (this.value[1]) {
        this.showInputEnd = true;
      }
      this.onStartChange('none', this.value[0]);
      this.onEndChange('none', this.value[1]);
    },
  };
</script>
<style lang="scss" scoped>
  .form-control-placeholder {
    left: 30px;
  }
  svg {
    position: absolute;
    left: 0;
    top: 6px;
    fill: #00405f;
  }
  .flatpicker-group /deep/ .form-control {
    padding-left: 30px;
  }
</style>
